import { mainCallModel } from 'APP/model/model';
import Entities from 'STORE';

interface IDeclineData {
  groupId?: string | null;
  channelId: string;
  reason?: string;
}

export const decline = async ({ groupId, channelId, reason }: IDeclineData): Promise<void> => {
  try {
    Entities.IncomingCalls.delete(channelId, groupId || null);
    await mainCallModel.declineCall(channelId, reason);
  } catch (e) {
    console.error(e);
  }
};
